import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';

import { PartyCustomFieldsComponent } from './party-custom-fields.component';
import { FormValidationModule, UtilsModule } from '@tablesready/common-ui';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';

@NgModule({
  declarations: [PartyCustomFieldsComponent],
  imports: [
    CommonModule,
    FormsModule,
    FormValidationModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbDatepickerModule,
    UtilsModule,
    FrontendDropdownModule,
  ],
  exports: [PartyCustomFieldsComponent],
})
export class PartyCustomFieldsModule {}
